import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { NavbarService } from '@app/services/shared/navbar.service';
import { FileService } from '@app/services/files/file.service';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css']
})
export class ContentComponent implements OnInit {
  html;
  popup = false;
  role;
  width = 160;
  height = 100;
  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
    private navbarService: NavbarService,
    private permissionService: PermissionsService,
    private fileService: FileService) { }

  ngOnInit() {
    this.permissionService.selectedrole.subscribe(r => {
      if (r) {
        this.role = r;
      }
    });
  }

  viewHelp(page: string) {
    fetch('/assets/helpfiles/' + page).then(res => res.text()).then(data => {
      this.html = this.sanitizer.bypassSecurityTrustHtml(data);
    });
  }

  openPopup() {
    this.popup = true;
    this.navbarService.helpopened$.next(false);
  }

  hidePopup() {
    this.navbarService.helpopened$.next(true);
  }

  viewVideo(videoName) {
    var new_window = window.open('', '_blank');
    // unfortunately autoplay does not work with many browsers due to a strict policy
    new_window.document.write('<!doctype html><html><head><title>Video</title><meta charset="UTF-8" /></head><body>' +
      '<div data-new-window><video autoplay controls style="width: 100%; height: auto;">' +
      '<source src="../../../../../assets/helpvideos/' + videoName + '" type="video/mp4"/></video></div>' + '</body></html>');
  }

  viewVideo2(url) {
    this.router.navigate([]).then(() => {
      window.open('/video?url=' + url, '_blank');
    });
  }
}
